export type ThemePreference = 'auto' | 'light' | 'dark';

const THEME_KEY = 'cow-theme';

export function getThemePreference(): ThemePreference {
  try {
    const stored = localStorage.getItem(THEME_KEY);
    if (stored === 'light' || stored === 'dark' || stored === 'auto') {
      return stored;
    }
  }
  catch {
    // localStorage unavailable (e.g. privacy mode) — fall back to auto
  }
  return 'auto';
}

// Drives the [data-theme] attribute on <html>. 'auto' removes the attribute so the
// prefers-color-scheme media queries take over; 'light'/'dark' force that theme.
export function applyThemePreference(theme: ThemePreference): void {
  const root = document.documentElement;
  if (theme === 'light' || theme === 'dark') {
    root.setAttribute('data-theme', theme);
  }
  else {
    root.removeAttribute('data-theme');
  }
}

export function setThemePreference(theme: ThemePreference): void {
  try {
    localStorage.setItem(THEME_KEY, theme);
  }
  catch {
    // Ignore persistence failures; the in-session choice still applies.
  }
  applyThemePreference(theme);
}
